export namespace ActionUrl {
    export const ACTION: string = "action";
    export const ACTION_NEW: string = "new";
    export const ACTION_EDIT: string = "edit";
    export const ACTION_CREATE: string = "create";
    export const ACTION_QUERYRESULTSBYID: string = "resultsById";
    export const ACTION_QUERYRESULTSBYPATH: string = "results";
    export const ACTION_ADHOCQUERY: string = "adHocQuery";
    export const ACTION_VSOPEN: string = "vsopen";
    export const ACTION_QUERY: string = "query";
    export const ACTION_QUERY_EDIT: string = "query-edit";
    export const ACTION_QUERY_CHARTS: string = "query-charts";
    export const ACTION_CONTRIBUTION: string = "contribution";
    export const ACTION_SEARCH: string = "search";
}

export namespace ActionParameters {
    export const ACTION: string = "_a";
    export const ID: string = "id";
    export const WITD: string = "witd";
    export const WORKITEMID: string = "workItemId";
    export const TRIAGE: string = "triage";
    export const TEMPQUERYID: string = "tempQueryId";
    export const TEMPLATEID: string = "templateId";
    export const PATH: string = "path";
    export const WIQL: string = "wiql";
    export const NEW_QUERY: string = "newQuery";
    export const SEARCHTEXT: string = "searchText";
    export const PARENTID: string = "parentId";
    export const FULLSCREEN: string = "fullScreen";
    export const VIEW: string = "view";
    export const ISVSOPEN: string = "isVSOpen";
    export const QUERYID: string = "queryId";
    export const CONTEXT: string = "context";
    export const NAME: string = "name";
    export const IMPORTDATA: string = "importData";
}
